import {subscribeToChanges} from './realtimeSubscriptions.js';

// One in-flight read, coalesced event bursts, bounded visible-tab fallback.
export function watchPontoonProgress({client,competitionId,league,refresh,documentTarget=document,windowTarget=window,intervalMs=30000}) {
  let active=true,busy=false,queued=false;
  const run=async()=>{
    if(!active)return;
    if(busy){queued=true;return;}
    busy=true;
    try{await refresh(()=>active);}finally{busy=false;if(active&&queued){queued=false;void run();}}
  };
  const cleanups=[
    subscribeToChanges(client,`pontoon-fixtures-${league}`,{event:'*',schema:'public',table:'fixtures',filter:`league=eq.${league}`},run),
    ...['pontoon_picks','pontoon_matchday'].map(table=>subscribeToChanges(client,`pontoon-${table}-${competitionId}`,{event:'*',schema:'public',table,filter:`competition_id=eq.${competitionId}`},run)),
  ];
  const visible=()=>{if(documentTarget.visibilityState!=='hidden')void run();};
  const timer=windowTarget.setInterval(visible,intervalMs);
  documentTarget.addEventListener('visibilitychange',visible);windowTarget.addEventListener('focus',visible);
  void run();
  return {refresh:run,stop(){active=false;queued=false;windowTarget.clearInterval(timer);documentTarget.removeEventListener('visibilitychange',visible);windowTarget.removeEventListener('focus',visible);cleanups.forEach(stop=>stop());}};
}
